import { type CservModulFormat, cservModulFormate } from '../dtos.js';

export const printModulFormat = (modulFormat: CservModulFormat): string => {
  switch (modulFormat) {
    case cservModulFormate.PRAESENZ_SEMINAR:
      return 'Präsenzseminar';
    case cservModulFormate.PRAESENZ_TRAINING:
      return 'Präsenztraining';
    case cservModulFormate.E_LEARNING:
      return 'E-Learning';
    case cservModulFormate.LERNIMPULS:
      return 'Lernimpulse';
    case cservModulFormate.ONLINE_SEMINAR:
      return 'Online-Seminar';
    case cservModulFormate.ONLINE_TRAINING:
      return 'Online-Training';
    case cservModulFormate.WEBINAR:
      return 'Webinar';
    case cservModulFormate.COACHING:
      return 'Coaching';
    case cservModulFormate.SELBSTLERNPHASE:
      return 'Selbstlernphase';
    case cservModulFormate.SELBSTLERNPHASE_MIT_WEBINAR:
      return 'Selbstlernphase mit Webinar';
    case cservModulFormate.PRUEFUNG:
      return 'Prüfung';
    case cservModulFormate.EPRUEFUNG:
      return 'E-Prüfung';
    case cservModulFormate.OPT_PREUFUNG:
      return 'Optionale Prüfung';
  }
};
